<template>
  <main>
    <!-- BANNER -->
    <RysBanner2
      :page="page"
      :mobilebanner="true"
    />

    <!-- DYNAMIC SECTIONS -->
    <RysDynamicSections
      class="dynamic-sections"
      :sections="page.acf.sections || []"
    />
  </main>
</template>

<script>
import yoastToVueMeta from '@/utils/yoast-to-vue-meta';

export default {
  name: 'RysStudentOpportunities',

  async setup() {
    const wpJson = useWp();

    const { data: page, error: pageError } = await useAsyncData(
      'page-gallery',
      () => wpJson.pages.getBySlug('gallery')
    );

    if (pageError.value) {
      throw createError({ status: 500, cause: pageError.value });
    }

    if (!page.value) {
      throw createError({ statusCode: 404 });
    }

    return { page };
  },

  head() {
    return yoastToVueMeta(this.page);
  }
};
</script>

<style lang="scss" scoped>
</style>
